/**
 * Secure logging utility that prevents sensitive information leakage in production.
 * In development, logs are shown in console for debugging.
 * In production, sensitive details are suppressed.
 */

const isDevelopment = import.meta.env.DEV;

export const logger = {
  /**
   * Log an error - in production, only logs a sanitized message
   */
  error: (message: string, error?: unknown) => {
    console.error(message, error);
  },

  /**
   * Log a warning - in production, only logs the message without details
   */
  warn: (message: string, data?: unknown) => {
    console.warn(message, data);
  },

  /**
   * Log info - in production, only logs the message without details
   */
  info: (message: string, data?: unknown) => {
    console.info(message, data);
  },

  /**
   * Log debug information - only in development
   */
  debug: (message: string, data?: unknown) => {
    console.log(message, data);
  },
};
